import ProductTemplate from "../../Biscuits-Template/Template";
import BisImg from "../../../assets/products/biscuits/digestive biscuit.png";
import BiscuitImg from "../../../assets/products/biscuits/Digestive-Biscuits.png";
import { Helmet } from "react-helmet-async";

const BiscuitData = [
  {
    grams: 200,
  },
];

export default function DigestiveProduct() {
  return (
    <>
      <Helmet>
        <title>
          Digestive Biscuits – BearBitz | Premium Biscuits & Cookies
        </title>
        <meta
          name="description"
          content="Explore BearBitz Digestive Biscuits — wholesome, fiber-rich, and ideal for healthy snacking. View pack sizes, cartons, and global specs."
        />
        <meta
          name="keywords"
          content="Digestive Biscuits, BearBitz Digestive Biscuits"
        />
        <link rel="canonical" href="https://www.bearbitz.in/biscuits/digestive" />
        <meta property="og:title" content="Digestive Biscuits – BearBitz" />
        <meta
          property="og:description"
          content="Wholesome and satisfying Digestive biscuits with premium packaging and export-ready specifications."
        />
      </Helmet>

      <ProductTemplate
        productTitle="DIGESTIVE BISCUITS"
        productImage={BisImg}
        description="Enjoy the natural goodness of Digestive Biscuits, made with the richness of whole wheat and packed with fiber. Lightly sweetened and perfectly crunchy, they make a healthy companion for tea."
        tableData={BiscuitData}
        BiscuitLogo={BiscuitImg}
        textColor="#9D1317"
        sectionBgColor="#FFEDAC"
        productBgcolor="#FFF8DE"
        tableheadBgcolor="#9D1317"
        tableBgcolor="#FBFBFB"
        footerBgcolor="#9D1317"
      />
    </>
  );
}
